import vsComponent from './vsSwitch';

export default Vue => {
  Vue.component(vsComponent.name, vsComponent);
};
